import { MethodChipCombinedProps } from './types';

const usePresenter = (props: MethodChipCombinedProps): MethodChipCombinedProps => {
  return props;
};

export default usePresenter;
